/** Attributes that must not appear in the desktop top facet bar (only in their dedicated selector, e.g. Last Seen). */
const EXCLUDED_TOP_FILTER_ATTRIBUTES = new Set(['normalisedTitle', 'lastSeenMin']);

/** Order for grouping active facets (matches TopFilters final display order). */
export const TOP_FILTER_ATTRIBUTE_ORDER = [
  'remoteness',
  'location',
  'jobType',
  'normalisedRoleLevel',
  'requiredLanguages',
  'field',
  'peopleManagementTier',
  'companyIndustry',
  'companyId',
] as const;

/** Order for building the raw facet list (matches TopFilters allFacetsRaw). */
export const ALL_TOP_FILTER_ATTRIBUTES_ORDER = [
  'remoteness',
  'location',
  'jobType',
  'normalisedRoleLevel',
  'companyIndustry',
  'companyId',
  'requiredLanguages',
  'benefits',
  'skillsAndTechnologies',
  'field',
  'educationLevel',
  'peopleManagementTier',
] as const;

export function shouldIncludeFacetInTopFilters(attribute: string): boolean {
  return !EXCLUDED_TOP_FILTER_ATTRIBUTES.has(attribute);
}








